import { useCallback } from 'react'
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3'

interface UseCaptchaOptions {
    onError?: (error: string) => void
}

/**
 * Hook para executar validação de captcha
 * Deve ser usado dentro de um CaptchaProvider
 */
export function useCaptcha(options?: UseCaptchaOptions) {
    const { executeRecaptcha } = useGoogleReCaptcha()
    const { onError } = options ?? {}
    const siteKey = import.meta.env.VITE_CAPTCHA_SITE_KEY

    const execute = useCallback(
        async (action: string = 'submit'): Promise<string | undefined> => {
            if (!siteKey) {
                return `bypass-${action}-${Date.now()}`
            }

            if (!executeRecaptcha) {
                onError?.('Captcha não está pronto')
                return undefined
            }

            try {
                const token = await executeRecaptcha(action)
                return token
            } catch (error) {
                onError?.('Erro ao executar captcha')
                return undefined
            }
        },
        [siteKey, executeRecaptcha, onError],
    )

    const isReady = siteKey ? !!executeRecaptcha : true

    return {
        execute,
        isReady,
    }
}
